import MenuItem from '@mui/material/MenuItem';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import appMessages from '~/containers/App/messages';
import messages from './messages';
import { cutoffDatesReleaseUntil } from '~/generated';
import { extractData } from '~/utils/query-utils';

type ReleaseWeekMenuItemProps = {
  releaseUntil: string;

  onCloseMenu: () => void;
};

const ReleaseWeekMenuItem = (props: ReleaseWeekMenuItemProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationKey: ['CutoffDates', 'release'],
    mutationFn() {
      return extractData(
        cutoffDatesReleaseUntil({
          body: {
            until: props.releaseUntil,
          },
        })
      );
    },
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.releaseWeekSuccess),
      });
      props.onCloseMenu();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.releaseWeekFailure),
      });
      props.onCloseMenu();
    },
  });
  return (
    <MenuItem disabled={mutation.isPending} onClick={() => mutation.mutate()}>
      {mutation.isPending
        ? intl.formatMessage(appMessages.loading)
        : intl.formatMessage(messages.releaseWeek)}
    </MenuItem>
  );
};

export default ReleaseWeekMenuItem;
